import { render, staticRenderFns } from "./LabelListTable.vue?vue&type=template&id=97336d9a"
import script from "./LabelListTable.vue?vue&type=script&lang=js"
export * from "./LabelListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports